import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { TooltipProvider } from '@/components/ui/tooltip'
import { AuthProvider } from '@/contexts/AuthContext'
import { Toaster } from '@/components/ui/toaster'
import { ScrollToTop } from '@/components/ScrollToTop'
import { ProfileDrawerProvider } from '@/contexts/ProfileDrawerContext'
import App from './App.tsx'
import './index.css'

// Prevent browser from restoring scroll positions
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const queryClient = new QueryClient()

createRoot(document.getElementById("root")!).render(
  <BrowserRouter future={{ v7_startTransition: true }}>
    <ScrollToTop />
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ProfileDrawerProvider>
          <TooltipProvider>
            <App />
            <Toaster />
          </TooltipProvider>
        </ProfileDrawerProvider>
      </AuthProvider>
    </QueryClientProvider>
  </BrowserRouter>
);
